import * as React from 'react'

import Svg, { Path, Rect } from 'react-native-svg'

import { IconProps } from '../icons'

const FolderWithColor = ({
  size = 36,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 36 36"
    fill="none"
    {...props}
  >
    <Rect width={36} height={36} rx={18} fill="#fff" />
    <Path
      d="M30 24.464a4 4 0 0 1-4 4H9a4 4 0 0 1-4-4V15.77a4 4 0 0 1 1.3-2.95l8.5-7.778a4 4 0 0 1 5.4 0l8.5 7.777A4 4 0 0 1 30 15.77v8.694Z"
      fill="#AAD5FF"
    />
    <Path
      d="M30 14.537a1.2 1.2 0 0 0-.39-.885L19.51 4.41c-.77-.704-2.01-.158-2.01.886v21.968a1.2 1.2 0 0 0 1.2 1.2h10.1a1.2 1.2 0 0 0 1.2-1.2V14.537Z"
      fill="#6DB6FF"
    />
    <Path d="M6.336 8.259h22.33v13.174H6.336V8.259Z" fill="#389CFF" />
    <Path d="M17.5 8.259h11.165v13.174H17.5V8.259Z" fill="#2E86DD" />
    <Path d="M8.102 9.982h18.8v9.727h-18.8V9.982Z" fill="#D5EAFF" />
    <Path d="M17.5 9.982h9.4v9.727h-9.4V9.982Z" fill="#AFD7FF" />
    <Path
      d="M17.499 18.299c1.35 0 2.444-1.546 2.444-3.453 0-1.907-1.094-3.452-2.444-3.452-1.35 0-2.444 1.545-2.444 3.452s1.094 3.453 2.444 3.453Z"
      fill="#fff"
    />
    <Path
      d="M19.944 14.846c0-1.906-1.095-3.452-2.444-3.452v6.904c1.35 0 2.444-1.546 2.444-3.452Z"
      fill="#F5F7FB"
    />
    <Path
      d="M11.215 16.494a1.649 1.649 0 1 0 0-3.297 1.649 1.649 0 0 0 0 3.297ZM23.786 16.494a1.649 1.649 0 1 0 0-3.297 1.649 1.649 0 0 0 0 3.297Z"
      fill="#fff"
    />
    <Path d="M5 14.009v14.456h25L5 14.009Z" fill="#CEE7FF" />
    <Path d="M30 14.009 5 28.465h25V14.009Z" fill="#AAD5FF" />
    <Path d="M17.5 21.236v7.228H30l-12.5-7.228Z" fill="#6DB6FF" />
  </Svg>
)

export default FolderWithColor
